import TheGrid from '@/views/regions/grid'
import Edit from '@/views/regions/edit'
import TheView from '@/views/regions/view'

export default {
  path: '/regions',
  redirect: '/regions/index',
  name: 'regions',
  meta: {
    auth: {
      redirect: {
        name: 'regions.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Regiões'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'regions.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'regions.create',
    component: Edit,
    meta: {
      auth: true,
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'regions.edit',
    component: Edit,
    meta: {
      auth: true,
      label: 'Editar'
    }
  }, {
    path: 'view/:id',
    name: 'regions.view',
    component: TheView,
    meta: {
      auth: true,
      label: 'Ver'
    }
  }]
}
